<app-navbar title="Termin wycieczki">
	<button class="btn btn-warning me-2" *ngIf="pageFunction !== 'add'" (click)="getPeople()">Anuluj termin</button>
	<a class="btn btn-danger" routerLink="../"> <i class="fas fa-chevron-left"></i> Powrót </a>
</app-navbar>

<app-resident-trip-list-filter
	userFilters="residentTripList"
	(selected)="filtersSelected($event)"
></app-resident-trip-list-filter>

<div class="container col-auto my-4">
	<div class="form-floating my-4">
		<select
			class="form-select"
			id="residentBaseTrips"
			name="residentBaseTrips"
			[(ngModel)]="data.residentBaseTrips"
			placeholder="Wycieczka"
			(change)="departuresDetail()"
		>
			<option selected></option>
			<option *ngFor="let item of residentBaseTrips" [value]="item.id">
				{{ item.name }} - [<span *ngFor="let obj of item.destinations">{{ obj.name }}, </span>]
			</option>
		</select>
		<label for="residentBaseTrips">Wycieczka</label>
	</div>
	<div class="form-floating my-4">
		<input type="date" [(ngModel)]="data.date" name="date" class="form-control" />
		<label for="date">Data</label>
	</div>
	<div class="form-floating my-4">
		<input
			type="number"
			[(ngModel)]="data.contigent"
			name="contigent"
			class="form-control"
			(change)="calculateFreePlaces()"
		/>
		<label for="contigent">Pojemność</label>
	</div>
	<div *ngFor="let item of data.departureDetail; let destinationsIndex = index">
		<h6>{{ item.name }}:</h6>
		<div class="row my-3">
			<div class="col">
				<div class="form-floating">
					<input
						type="time"
						name="time_{{ destinationsIndex }}"
						[(ngModel)]="data.departureDetail[destinationsIndex].time"
						class="form-control"
					/>
					<label for="time_{{ destinationsIndex }}">Godzina</label>
				</div>
			</div>
			<div class="col">
				<div class="form-floating">
					<select
						class="form-select"
						name="bagStopsId_{{ destinationsIndex }}"
						[(ngModel)]="data.departureDetail[destinationsIndex].bagStopsId"
					>
						<option *ngFor="let item of filteredBagStops" [value]="item.id">
							{{ item.address }} - {{ item.name }}
						</option>
					</select>
					<label for="bagStopsId_{{ destinationsIndex }}">Adres</label>
				</div>
			</div>
			<div class="col">
				<div class="form-floating">
					<input
						type="number"
						name="surchargeEUR_{{ destinationsIndex }}"
						[(ngModel)]="data.departureDetail[destinationsIndex].surchargeEUR"
						class="form-control"
					/>
					<label for="surchargeEUR_{{ destinationsIndex }}">Dopłata EUR</label>
				</div>
			</div>
			<div class="col">
				<div class="form-floating">
					<input
						type="number"
						name="surchargeHR_{{ destinationsIndex }}"
						[(ngModel)]="data.departureDetail[destinationsIndex].surchargeHR"
						class="form-control"
					/>
					<label for="surchargeHR_{{ destinationsIndex }}">Dopłata HR</label>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="container col-auto my-4">
	<div class="d-flex flex-row-reverse">
		<button class="btn btn-primary" (click)="save()">Zapisz</button>
	</div>
</div>
